import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { MechanicValidatorBarbarianInvasion } from '@colonist/game-mechanic-validators';
import { usePlayerValidators } from './usePlayerValidators.ts';
import { useMapValidator } from './useMapValidator.ts';
export const useBarbarianInvasionValidator = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const barbarianInvasionState = useGameStore((state)=>state.gameState.mechanicBarbarianInvasionState);
    if (barbarianInvasionState == undefined) return undefined;
    return useMemo(()=>{
        const validator = new MechanicValidatorBarbarianInvasion(playerValidators, mapValidator, barbarianInvasionState);
        return validator;
    }, [
        playerValidators,
        mapValidator,
        barbarianInvasionState
    ]);
};
